import Icon from '@/componentsDS/Icon/Icon'
import Badge from '@/componentsDS/Badge/Badge'
import PropTypes from 'prop-types';


const NotificationBell = ({ isActive, handleIconClick, unseenNotifications }) => {

	return (
		<div role='none'  onClick={() => handleIconClick(!isActive)} className='notification-bell-icon' data-testid="bell-icon">
			<Badge notificationArray={unseenNotifications} iconImg={<Icon name="notificationBell" size="medium" style="outlined" />} />
		</div>
	)

}

export default NotificationBell
NotificationBell.propTypes = {
	isActive: PropTypes.bool.isRequired,
	handleIconClick: PropTypes.func.isRequired,
	unseenNotifications: PropTypes.array
};
